export default angular.module("configuration.http", []).config(function ($httpProvider, $locationProvider) {
  $httpProvider.interceptors.push("httpInterceptor");
}).name;
